const trimTrailingEmptyLines = (lines: string[]) => {
  const result = [...lines];

  while (result.length > 0 && result[result.length - 1] === '') {
    result.pop();
  }

  return result;
};

const splitLines = (text: string) =>
  text.replace(/^\uFEFF/, '').split(/\r\n|\r|\n/);

export const mergeCsvFiles = async (blobs: Blob[]): Promise<Blob> => {
  if (blobs.length === 0) {
    throw new Error('No files to merge');
  }

  const texts = await Promise.all(blobs.map((blob) => blob.text()));
  const mergedLines: string[] = [];
  let header: string | null = null;

  texts.forEach((text) => {
    const lines = trimTrailingEmptyLines(splitLines(text));

    if (lines.length === 0) {
      return;
    }

    if (header === null) {
      header = lines[0];
      mergedLines.push(...lines);
      return;
    }

    const body = lines[0] === header ? lines.slice(1) : lines;
    mergedLines.push(...body);
  });

  if (mergedLines.length === 0) {
    throw new Error('No CSV content to merge');
  }

  return new Blob([`${mergedLines.join('\n')}\n`], { type: 'text/csv' });
};
